import ShippingPreferencesSearch from "./ShippingPreferencesSearch";
export default ShippingPreferencesSearch;
